exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.file-input_container_3QJO5 {\r\n    display: block;\r\n    position: relative;\r\n    padding: 1rem;\r\n    margin: 1rem 0;\r\n    text-align: center;\r\n    border: 4px dashed var(--ui-tertiary);\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    background: none;\r\n    width: 100%;\r\n}\r\n\r\n.file-input_container_3QJO5:focus-within {\r\n    border-color: var(--looks-secondary);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "file-input_container_3QJO5"
};